/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c89f71eae4751b83c783ff36e1def0ae>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "DiagramSymbolDecision".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/diagram-symbol-decision
 * Usage guidance:
 * Reserved for decision diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const DiagramSymbolDecisionIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "DiagramSymbolDecisionIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M7.132.317a1.376 1.376 0 0 1 1.736 0l.105.094 6.616 6.616.094.105a1.376 1.376 0 0 1 0 1.736l-.094.105-6.616 6.616a1.377 1.377 0 0 1-1.841.094l-.105-.094L.411 8.973a1.376 1.376 0 0 1 0-1.946L7.027.411zM1.562 8 8 14.438 14.438 8 8 1.561z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
DiagramSymbolDecisionIcon.displayName = 'DiagramSymbolDecisionIcon';
var _default = exports.default = DiagramSymbolDecisionIcon;